// extracted by mini-css-extract-plugin
export default {"cell-wrap":"dcF32","cell-wrap--disabled":"kfgX4","cell-wrap__content":"ewIiz","cell-wrap--dividered":"aHeAz"};